import React, { useMemo, useState, useCallback } from "react";
import styled from "styled-components";
import { useFormikContext } from "formik";
import useViewsSelector from "views/stores/useViewsSelector";
import { Icon } from "components/common";
import { Button } from "components/bootstrap";
import CreateParameterDialog from "enterprise/parameters/creatoractions/CreateParameterDialog";
import { selectSearchId } from "views/logic/slices/viewSelectors";
import useParameters from "views/hooks/useParameters";
import { removeParameter, updateParameter } from "views/logic/slices/searchExecutionSlice";
import useViewsDispatch from "views/stores/useViewsDispatch";
import Parameter from "./Parameter";
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
`;
const CreateButton = styled(Button)(
  ({ $displaySpacer }) => `
  margin-left: 5px;
  margin-right: ${$displaySpacer ? "5px;" : "0"};
`
);
const Parameters = () => {
  const { setFieldValue } = useFormikContext();
  const { parameters } = useParameters();
  const searchId = useViewsSelector(selectSearchId);
  const [isCreateFormOpen, setIsCreateFormOpen] = useState(false);
  const toggleIsCreateFormOpen = useCallback(() => setIsCreateFormOpen((isOpen) => !isOpen), []);
  const dispatch = useViewsDispatch();
  const handleRemoveParameter = useCallback(
    (parameterName) => dispatch(removeParameter(parameterName)),
    [dispatch]
  );
  const handleEdit = useCallback(
    (name, parameter) => dispatch(updateParameter(name, parameter)),
    [dispatch]
  );
  const parameterFields = useMemo(() => {
    const onDelete = (parameterName, formFieldName) => handleRemoveParameter(parameterName).then(() => {
      setFieldValue(formFieldName, void 0);
    });
    return parameters.sort((p1, p2) => p1.title.localeCompare(p2.title)).map((param) => /* @__PURE__ */ React.createElement("div", { key: param.name }, /* @__PURE__ */ React.createElement(Parameter, { parameter: param, searchId, onDelete, onEdit: handleEdit }))).valueSeq().toArray();
  }, [handleEdit, handleRemoveParameter, parameters, searchId, setFieldValue]);
  return /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement("div", null, "Parameters", /* @__PURE__ */ React.createElement(
    CreateButton,
    {
      bsSize: "small",
      onClick: toggleIsCreateFormOpen,
      title: "Declare parameters",
      $displaySpacer: !!(parameterFields == null ? void 0 : parameterFields.length)
    },
    /* @__PURE__ */ React.createElement(Icon, { name: "add" })
  ), isCreateFormOpen && /* @__PURE__ */ React.createElement(CreateParameterDialog, { onClose: toggleIsCreateFormOpen })), parameterFields);
};
export default Parameters;
